"use client"

import type React from "react"

interface TextFormProps {
  text: string
  onChange: (text: string) => void
}

const TextForm: React.FC<TextFormProps> = ({ text, onChange }) => {
  return (
    <div className="form-group">
      <label htmlFor="text-input">Text Content:</label>
      <textarea
        id="text-input"
        value={text}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Enter your text here"
        className="text-input text-area"
        rows={4}
      />
    </div>
  )
}

export default TextForm
